import { TraitRegistryItem } from '../TraitRegistryItem';
export class TraitTypeCustom extends TraitRegistryItem {
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
    traitType = 'custom';
}
